import { buildMiddleware } from 'utilities/state';
import { DateTime } from 'luxon';
import { processCard } from 'areas/cards/domain';

const stateKey = 'swipes';
const configKey = 'config';
const storeConfigKey = 'store:config';
const storeKey = 'store:swipes';
const locationKey = 'store:location';
const locationConfigKey = 'store:supervisor';
const cardStoreKey = 'store:cards.cardData';
const passStoreKey = 'store:cards.passes';

const DefaultSwipeHistoryRetentionInHours = 12;

const removeExpiredSwipes = (swipes, retentionTimeHours) =>
    (swipes || []).filter(s => {
        const swipeDate = DateTime.fromISO(s.swipeTime);
        const dateDiff = swipeDate.diffNow().as('hours');
        return Math.abs(dateDiff) < retentionTimeHours;
    });

// removes the card data from the swipe history and replaces this with the key of the QR code
// that needs to be rehydrated
const fromSwipes = (swipeData, appConfig) => {

    const filteredSwipes = removeExpiredSwipes(
        swipeData.swipes,
        appConfig ? appConfig.swipeHistoryValidityInHours : DefaultSwipeHistoryRetentionInHours);

    return {
        ...swipeData,
        swipes: filteredSwipes.map(s => {
            return {
                ...s,
                qrCode: s.card ? s.card.qrCode : s.visitorPass.qrCode,
                card: null,
                visitorPass: null
            }
        })
    }
};

// rehydrates a swipe data by adding back the card data
const toSwipes = (storedSwipes, storedCards, storedPasses, location, locationConfig, config) => {
    return {
        ...storedSwipes,
        uiState: storedSwipes.uiState || {
            timeToWork: [0, 0],
            timeFromWork: [0, 0],
            selectedEmployer: '',
            selectedJobRole: ''
        },
        swipes: (storedSwipes.swipes || []).map(s => {
            return {
                ...s,
                card: processCard(storedCards[s.qrCode] || {}, location, locationConfig, config),
                visitorPass: storedPasses[s.qrCode] || {}
            }
        })
    }
};

const stateChanged = (appStore, state) => {
    appStore.set(storeKey, fromSwipes(state[stateKey] || { swipes: [] }, state[configKey]));
};

const initialiseState = (appStore, state) => {
    state[stateKey] =
        toSwipes(
            appStore.get(storeKey) || {},
            appStore.get(cardStoreKey) || {},
            appStore.get(passStoreKey) || {},
            appStore.get(locationKey),
            appStore.get(locationConfigKey),
            appStore.get(storeConfigKey));
};

export default buildMiddleware(stateChanged, initialiseState);